// src/services/DocumentTemplateService.ts
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { DocumentTemplate } from "@visitproof/types";
import { db } from "../firebase";

const documentTemplateCollectionRef = collection(db, "documentTemplates");

export const DocumentTemplateService = {
  async getDocumentTemplate(
    documentTemplateId: string,
  ): Promise<DocumentTemplate | null> {
    const documentTemplateDoc = await getDoc(
      doc(documentTemplateCollectionRef, documentTemplateId),
    );
    if (documentTemplateDoc.exists()) {
      return {
        id: documentTemplateDoc.id,
        ...documentTemplateDoc.data(),
      } as DocumentTemplate;
    }
    return null;
  },

  async getAllDocumentTemplates(
    accountId: string,
  ): Promise<DocumentTemplate[]> {
    const documentTemplateSnapshot = await getDocs(
      query(documentTemplateCollectionRef, where("accountId", "==", accountId)),
    );
    return documentTemplateSnapshot.docs.map(
      (doc) => ({ id: doc.id, ...doc.data() }) as DocumentTemplate,
    );
  },
};
